module.exports = {
  buttons: {
    add: '新建',
    back: '返回',
    cancel: '取消',
    clear: '清空',
    fields: '字段',
    filter: '筛选',
    ok: '确定',
    refresh: '刷新',
    reset: '重置',
    save: '保存'
  }
};



/** WEBPACK FOOTER **
 ** ./src/lang/zh-cn/buttons.js
 **/